import { render, staticRenderFns } from "./home.vue?vue&type=template&id=0c1a5a5e&scoped=true"
import script from "./home?vue&type=script&lang=js&external"
export * from "./home?vue&type=script&lang=js&external"
import style0 from "./home.vue?vue&type=style&index=0&id=0c1a5a5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1a5a5e",
  null
  
)

export default component.exports